<div class="footerRow">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">

                &copy; 2023 MoneyMarket.mx
                <a [routerLink]="[ '/']" queryParamsHandling="preserve" rel="dofollow"> INICIO</a>
                <a [routerLink]="[ '/como-funciona']" queryParamsHandling="preserve" rel="dofollow">&iquest;C&Oacute;MO
                    FUNCIONA?</a>
                <a [routerLink]="[ '/sobre-nosotros']" queryParamsHandling="preserve" rel="dofollow">SOBRE NOSOTROS</a>
                <a [routerLink]="[ '/blog']" queryParamsHandling="preserve" rel="dofollow">BLOG</a>
                <a [routerLink]="[ '/preguntas-frecuentes']" queryParamsHandling="preserve" rel="dofollow">PREGUNTAS
                    FRECUENTES</a>
                <a [routerLink]="[ '/aviso-de-privacidad']" queryParamsHandling="preserve" rel="dofollow">AVISO DE
                    PRIVACIDAD</a>
                <a [routerLink]="[ '/terminos-y-condiciones']" queryParamsHandling="preserve" rel="dofollow">
                    T&Eacute;RMINOS Y
                    CONDICIONES</a>
                <a [routerLink]="[ '/tarifas-y-terminos']" queryParamsHandling="preserve" rel="dofollow">TARIFAS Y
                    T&Eacute;RMINOS</a>
                <a [routerLink]="[ '/contacto']" queryParamsHandling="preserve" rel="dofollow">CONT&Aacute;CTANOS</a>
                <a [routerLink]="[ '/']" queryParamsHandling="preserve">SOLICITAR PRÉSTAMO</a>

                <hr>
                <p> Para solicitar tu préstamo en algunas de las compañias con las que trabajamos, recuerda cumplir con
                    los
                    siguientes requisitos: <br>
                    <strong> Ser mayor de edad, tener nacionalidad mexicana, tener INE y contar con una cuenta bancaria
                        propia</strong>
                </p>

                <p>Por favor, ten en cuenta que las solicitudes para un préstamo quedan a discreción de cada
                    prestamista.
                </p>

                <p> <strong> <a [routerLink]="['/blog/avafin-prestamos']" queryParamsHandling="preserve" rel="dofollow">
                            AVAFIN</a></strong>
                    CAT promedio de 5045%, SIN IVA.
                    Tasa de interés ordinario anual simple fija de 459%.
                    Tasa de interés moratorio fija anual de 504%.</p>

                <p> <strong>MONEYMAN</strong>
                    0% de interés en tu primer préstamo
                    CAT promedio porcentual anual de 3,696.85%, más IVA.
                    Tasa de interés ordinaria fija anual es de 424.80%, más IVA.
                    Tasa de interés moratorio fija anual de 295.2%, más IVA. (Calculado sobre un préstamo de $3,000
                    pesos).
                </p>
                <hr>


                <br /><br />

                MoneyMarket.mx es una marca comercial de OJO7MX SA de CV. La oficina registrada se encuentra en
                C. Río Tiber 87, Cuauhtémoc, 06500 Ciudad de México, CDMX, Mexico.
                EL OPERADOR DE ESTA WEB NO ES UN PRESTAMISTA, no negocia pr&eacute;stamos con prestamistas, no hace
                pr&eacute;stamos personales ni toma decisiones de cr&eacute;dito. Este sitio web no constituye una
                oferta o solicitud de pr&eacute;stamo. Somos un servicio que conecta a prestamistas con personas que
                necesitan un cr&eacute;dito personal. Esta web enviar&aacute; tu informaci&oacute;n a un prestamista.
                Dar tu informaci&oacute;n en esta web no garantiza que tu solicitud de cr&eacute;dito ser&aacute;
                aprobada. El operador de esta web no es un agente, representante o corredor de bolsa de ning&uacute;n
                prestamista, y no te promociona ni cobra por ning&uacute;n producto o servicio.
                <br /><br />
                &copy; OJO7MX SA de CV 2023.




            </div>
        </div>
    </div>
</div>